import { type CreateConfluencePageSuccessResponse } from './types';

export const getCreateConfluencePageURL = ({
	cloudId,
	gatewayBaseUrl = '',
}: {
	cloudId: string;
	gatewayBaseUrl: string;
}) =>
	`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/pages?${new URLSearchParams({
		expand: 'space',
	}).toString()}`;

export const getURLFromConfluencePageResponse = ({
	data,
	hostname,
}: {
	data: CreateConfluencePageSuccessResponse;
	hostname?: string;
}) => {
	if (data.errors) {
		throw new Error(`Error creating confluence page: ${data.errors[0].title}`);
	}

	// In case something went wrong but is not an error
	if (!data.id || !data.spaceId) {
		throw new Error('Something went wrong...');
	}

	let domain = '';
	if (typeof window.location !== 'undefined') {
		domain = hostname ?? window.location.origin;
	}

	//Create edit link if status is draft
	const pages = data.status === 'draft' ? 'pages/edit-v2' : 'pages';

	// Success:: build and return URL from the response data
	return `${domain}/wiki/spaces/${data.spaceId}/${pages}/${data.id}/`;
};
